import React, {useState, useEffect, useCallback, useRef} from "react";
import "./History.scss";
import { actionHandler } from "action/parseAction";
import {
  getSwapHistoriesAction,
} from "action/swap/public";
import { MainNetInfo } from "server/swap/type";
import { useSelector } from "react-redux";
import { account_info } from "reducer/account";
import { WrapTokenWithCurrency } from "reducer/swap/type";
import _ from "lodash";
// @ts-ignore
import arrowIcon from 'view/assets/images/history/arrow-icon.png'
import dayjs from "dayjs";
import {formatNumber} from "../../utils/numberUtil";
import {WEB3} from "../../modules/web3/Web3";
import classNames from "classnames";
import {useOutletContext} from "react-router-dom";
import PullToRefresh from 'react-simple-pull-to-refresh';

const LIMIT = 10;

function History() {

  const ref = useRef(null);

  const {swapData} = useOutletContext();

  // Redux
  const account = useSelector(account_info);

  // State
  const [swapHistories, setSwapHistories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEnd, setIsEnd] = useState(false);

  const getSwaps = useCallback(async (lastId) => {
    if(!swapData?.wrapTokens) {
      return;
    }

    await actionHandler(
      getSwapHistoriesAction({
        address: account.userInfo.new_address,
        limit: LIMIT,
        lastId,
        wrapTokens: swapData.wrapTokens,
      }),
      (res) => {
        console.log(res)
        if(res.length < LIMIT) {
          setIsEnd(true)
        }
        if(lastId){
          setSwapHistories(prevState => _.uniqBy([...prevState, ...res], 'swapId'))
        } else {
          setSwapHistories(res)
        }
      }
    );
    setIsLoading(false)
  }, [account, swapData]);



  const getTokenInfo = useCallback((tokenId) => {
    return swapData?.wrapTokens?.find(wrapToken => {
      return wrapToken.wrapTokenId === tokenId
    })
  }, [swapData])

  const getStatus = useCallback((status) => {
    switch (status) {
      case 0:
        return {
          text: 'Failed',
          className: 'failed'
        }
      case 1:
        return {
          text: 'Completed',
          className: 'completed'
        }
      default:
        return {
          text: 'Pending',
          className: 'pending'
        }
    }
  }, [])



  const loadMore = useCallback(async () => {
    console.log('load more')
    if(isLoading || isEnd) {
      return;
    }
    if(!swapHistories?.length) {
      return;
    }
    setIsLoading(true)
    getSwaps(swapHistories[swapHistories.length - 1].swapId)
  }, [swapHistories, getSwaps, isLoading, isEnd])

  useEffect(() => {
    if(!account?.userInfo?.new_address || !swapData) {
      return () => {}
    }
    getSwaps(0)
  }, [account, swapData, getSwaps]);

  const observer = new IntersectionObserver(loadMore, {threshold: 0.5});

  useEffect(() => {
    if(!account?.userInfo?.new_address || !swapData) {
      return () => {}
    }
    observer.observe(ref.current);
  }, [swapData, account, ref, loadMore]);

  return (
    <div id={"History"}>
      <PullToRefresh onRefresh={async () => {await getSwaps(0)}}>
        {
          swapHistories?.map((swapHistory, index) => {
            return <div className={'swap-history'} key={`swap-history-${index}`}>
              <div className={'swap-history-top'}>
                <div className={'swap-history-status-container'}>
                  <p className={'swap-history-time'}>{dayjs(swapHistory.updatedAt).format("DD-MM HH:mm:ss")}</p>
                  <p className={classNames('swap-history-status', getStatus(swapHistory.status).className)}>{getStatus(swapHistory.status).text}</p>
                </div>
                <p className={'swap-history-fee'}>Fee : {formatNumber(WEB3.fromWei(swapHistory.totalNetworkFee))} {getTokenInfo(swapHistory.fromTokenId)?.unit}</p>
              </div>
              <div className={'swap-history-bottom'}>
                <div className={'swap-history-from'}>
                  <div className={'swap-history-token-container'}>
                    <img className={'swap-history-token-image'} src={getTokenInfo(swapHistory.fromTokenId)?.currency.image} alt={'from'} />
                    <p className={'swap-history-token-symbol'}>{getTokenInfo(swapHistory.fromTokenId)?.unit}</p>
                  </div>
                  <p className={'swap-history-token-value'}>{formatNumber(WEB3.fromWei(swapHistory.fromTokenValue))}</p>
                </div>
                <img className={'swap-history-arrow'} src={arrowIcon} alt={'to'}/>
                <div className={'swap-history-to'}>
                  <div className={'swap-history-token-container'}>
                    <img className={'swap-history-token-image'} src={getTokenInfo(swapHistory.toTokenId)?.currency.image} alt={'from'} />
                    <p className={'swap-history-token-symbol'}>{getTokenInfo(swapHistory.toTokenId)?.unit}</p>
                  </div>
                  <p className={'swap-history-token-value'}>{formatNumber(WEB3.fromWei(swapHistory.toTokenValue))}</p>
                </div>
              </div>
            </div>
          })
        }
      <div className={'swap-scroll-observer'} ref={ref}/>
      </PullToRefresh>

    </div>
  );
}

export default History;
